'use client';

import { RefObject, useEffect, useState } from 'react';

export function useHasOverflow(ref: RefObject<HTMLElement | null>, deps: unknown[] = []): boolean {
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return;
    }

    const measure = () => setHasOverflow(element.scrollHeight > element.clientHeight);

    measure();

    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    for (const child of Array.from(element.children)) {
      observer.observe(child);
    }

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps]);

  return hasOverflow;
}
